import {
  normalizeRouteAuth,
  type RouteAuthMode,
} from "../../shared/monitoringRouteAuth";

export type RouteAccessInput = {
  route: string;
  stepDir: string;
  title: string | null;
  routeType: string | null;
  routeAuth: string | null;
};

export type RouteAccessChange = {
  route: string;
  stepDir: string;
  title: string | null;
  routeType: string | null;
  from: RouteAuthMode | null;
  to: RouteAuthMode;
};

// No-sign-in scopes. A link that is new in the draft is only worth flagging
// when it lands on one of these, so routine new space-scoped links stay quiet.
const EXPOSED_SCOPES: RouteAuthMode[] = ["public", "external_id"];

// Links whose access scope differs from what's live: an existing link that
// changed scope in either direction, or a link new to the draft that lands
// exposed (its biggest possible change). Removed links are ignored — dropping a
// link only ever narrows access.
export function changedRouteAccess(
  draftRoutes: readonly RouteAccessInput[],
  liveRoutes: readonly RouteAccessInput[]
): RouteAccessChange[] {
  const liveScopeByRoute = new Map<string, RouteAuthMode>();
  for (const r of liveRoutes)
    liveScopeByRoute.set(r.route, normalizeRouteAuth(r.routeAuth));

  const changes: RouteAccessChange[] = [];
  for (const r of draftRoutes) {
    const to = normalizeRouteAuth(r.routeAuth);
    const from = liveScopeByRoute.get(r.route) ?? null;
    const changed = from === null ? EXPOSED_SCOPES.includes(to) : from !== to;
    if (changed) {
      changes.push({
        route: r.route,
        stepDir: r.stepDir,
        title: r.title,
        routeType: r.routeType,
        from,
        to,
      });
    }
  }
  return changes;
}
